'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$00247 from "./presto.-Two-Factor-Auth-View$$anon$7.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$6(outer) {
  this.bFB = null;
  this.bFz = null;
  this.bFA = false;
  this.bFx = null;
  this.bFy = false;
  this.bFC = false;
  this.bFD = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bFB = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$6 as $c_Lpresto_TwoFactorAuthView$$anon$6 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$6.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$6;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$6() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$6 as $h_Lpresto_TwoFactorAuthView$$anon$6 };
$h_Lpresto_TwoFactorAuthView$$anon$6.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bFB;
});
$p.t = (function() {
  if ((!this.bFA)) {
    this.bFz = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("seeds", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("invites", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bFA = true;
  }
  return this.bFz;
});
$p.ae = (function() {
  if ((!this.bFy)) {
    this.bFx = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$25(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$00247.$c_Lpresto_TwoFactorAuthView$$anon$7()), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$25($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().p8()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bFy = true;
  }
  return this.bFx;
});
$p.w = (function() {
  if ((!this.bFD)) {
    this.bFC = false;
    this.bFD = true;
  }
  return this.bFC;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_TwoFactorAuthView$$anon$6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$6, "presto.TwoFactorAuthView$$anon$6", ({
  SY: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$6 as $d_Lpresto_TwoFactorAuthView$$anon$6 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$6.js.map
